export class TypeAlert {
  public static readonly WHATSTAPP = 1;
  public static readonly EMAIL = 1;
}
